import { render, staticRenderFns } from "./gradeCertificate.vue?vue&type=template&id=477e9192&scoped=true"
import script from "./gradeCertificate.vue?vue&type=script&lang=js"
export * from "./gradeCertificate.vue?vue&type=script&lang=js"
import style0 from "./gradeCertificate.vue?vue&type=style&index=0&id=477e9192&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477e9192",
  null
  
)

export default component.exports